<template>
    <main id="mainCtrl">
        <header>
            <button @click="createAccount" v-if="$can('admin.clinics.create')">
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAANxSURBVHhe7ZxLqE1RGMevV4QQSpRHXqEUeRRRkhhQRoiJlIkod4RiwAAlBlKkmBAGMqBQDCgGlKIMyEAUKSmEvB+/T3e3v7tb69xz9jpnn3XO/n71G5z32v9zz1rf+vY5t8NoXwbhOpz+/5JREzPxGf7FH7gNjSrZgF9QwtOexYFoeOiHRzEbnPYRTkYjwxi8izqsT7gFH6jrxPe4Co0uFuMb1CE9xRkoDMDTqG//g/uwN5aaTvyJOpxLOASzbMZvqO97HUdg6RiMF1CH8Qt3Yi/0MQ9fon7cc5yNpWEqPkYdwltcitUwEm+ifvxX3IRtz2r8iPrg7+NYrIU+eABlLtTPdQL7Y9vRqAN2vSH3sNY3JGoa/ZELnRKiZi4WMen7FqUdWGlRippmlB1SFsneWb+mryyKFil8T6E+iCILX1dh/gRboqszHmPYevm2hmsxWpbjO9SDls3/JGwGruaEfBIOY1+MBpmkd6NM2nqwsbSfXO2xWzgKm85QvIx6cDKJb8WY0A3axFe4AJuGb1ALMUaG4RXU4/2OTXmz1+Nn1IO5jVF8LCrgm27OYCHTjW9iPoJRTcw9sAKzC95DnIgNYzTeQf2i0ZcGFfCVXCux7viK06Rr3Kq4ut2/cS/Wrejfji2/PeoB17bzGg7H3MgG/TzqJ235DXoFfN3uWVgzU7BtW0QV8LXeNmLVuJqUskK1VZOyAtL8lapCH7/YY/PX1zUWD2KZkE1CNgPRe/pBisgb6HqQaAGmylQ2H7shOwt9J5k8Je3kcpEBTsBlDhdhUWQDzHa7r2I3ZKWRfaHcKF1jWb7PdV0WiwxwFyavq5UVsiiyAQr6SwD75YossvIuwaREsQBTE6S3qTOqiAWYmgsLMDUXFmBqLizA1FxYgKm5sABTc2EBpubCAkzNRT0DlDaRnG+oxkOoB5/4Gl33dynbwRCiC/A46gE12g8YggWIIViAGIIFiCFYgBiCBYghRBfgOJxTpcdQDz5RTuy77u8y16lIRXQB1oIV0oFYgIFYgIFYgIFYgIFYgIFYgIFYgIFYgIFYgIFMwzUOG/Llbw8tHWAMWICBWICBWICBWICBWICBWICBWICBWICBWICB1D1A+anXyRJ5EesaYNnNhfyYxPVkZfMF5kL+EfYedP2Jl0X5/xAyHxqGYRhGveno+AeEC0bs4pPXqgAAAABJRU5ErkJggg=="
                     width="25"
                     height="25"
                >
                <span>
                    Добавить клинику
                </span>
            </button>

            <button @click="openClinicGlueDialog" v-if="$can('admin.clinics.merge')">
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHiSURBVGhD7Zm7TsMwFEALA/AxjIyMSPwDIwMjjy9B7IgfgBUYGPkOBhYEAzMTj3vaXsmy7hV2GstO5SMd0ZK0yVGcxGpmnU6nszZcik+F3RWL8yz+FnZfLM5ahlyLJyP5KVYLOeIfI/Eq9pAhpIRsLP/m0FzIsfggbs/fpdNUCBE/IssexTCGo3SxeGnSTAg7ypHQZagxLONGys56NHVE2Gl2Xpcj76+WrycTAlaMOqkQ8GJSQ87Fgwz3xGxSQjgndDiFeiFb4rsYr58q+5TNfyF6YocbUr2QO9FaP9UiIafii6O3wUPxS+Q730Trs7EfYtGQVHZEojfn7xYxtyLDLAW2XT2ECL0Y3Igak0P1kDBCPRNzqR7CcNLPI1HhVCaV6iEMI4bTKhFQJYQTmBOZExqIYTgNjYBRQ7gEWpfGWC6prM8lVmNi+F7rs8hwjBk1ZIgcGYtwihLKzdWiagjTEO8+YYUwzfFYOYQJmjVx82QCqBv0pihghXAx4HJtsXJILkzJdYO5IejFNB/CcIpvmFZM0yF6Ylt3/3uRmbXSbEj8w0QY8y3yw0ZIsyEWxHAk4giYVAiEwylkciEePWQoYQiPDqxHCkPkkUa1kFL2kBx4sGk98BxTb4bc6XQ6k2I2+wOpaR7aXP2juAAAAABJRU5ErkJggg=="
                     width="25"
                     height="25"
                >
                <span>
                    Объединить клиники
                </span>
            </button>
        </header>

        <ClinicEdit
            ref="clinicEditDialog"
            :user-options="userOptions"
            :competitors="competitors"
        />
        <ClinicNotFound ref="clinicNotFound"/>
        <ClinicModeration ref="clinicModeration" @updated="onUpdatedEvent" />
        <GlueClinicDialog ref="glueClinicDialog" @updated="onUpdatedEvent" :competitors="competitors" />

        <v-table id="table"
                 :lazycount="true"
                 request-uri="clinics/getList"
                 pagesize="50"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th name="city" sort="city" width="45">
                        Город
                    </v-th>
                    <v-th name="created_at" sort="created_at" width="70">
                        Создана
                    </v-th>
                    <v-th name="moderationNeeded" width="60" tooltip="Требуется модерация">
                        М
                    </v-th>
                    <v-th name="img" width="50">
                        Лого
                    </v-th>
                    <v-th name="nameOrAddress" sort="clinics.name" minwidth="150">
                        Клиника
                    </v-th>
                    <v-th name="rating" sort="rating" width="30" tooltip="Рейтинг">
                        <i class="fas fa-star-half-alt"></i>
                    </v-th>
                    <v-th name="network" width="150">
                        Сеть
                    </v-th>
                    <v-th name="parent" sort="parent_id" width="150">
                        Родительская
                    </v-th>
                    <v-th name="children" width="150">
                        Дочерние
                    </v-th>
                    <v-th name="type" sort="types" width="150">
                        Категории
                    </v-th>
                    <v-th name="registryPhone" sort="registryPhone" width="115">
                        Тел клиники
                    </v-th>
                    <v-th name="doctuPhone" sort="phone" width="115">
                        Тел Doctu.ru
                    </v-th>
                    <v-th name="doctors_count" sort="doctors_count" tooltip="Врачей в клинике" width="45">
                        <i class="fas fa-user-doctor"></i>
                    </v-th>
                    <v-th name="url" sort="url" width="100">
                        URL
                    </v-th>
                    <v-th name="website" sort="website" width="120">
                        Сайт
                    </v-th>
                    <v-th name="subscriptionTariff" width="100">
                        Тариф
                    </v-th>
                    <v-th name="subscriptionOptions" tooltip="Опции подписки" width="85">
                        Опции
                    </v-th>
                    <v-th name="reportManager_id" sort="reportManager_id" width="70" tooltip="Менеджер">
                        Мен
                    </v-th>
                    <v-th name="subscriptionActivity" width="75">
                        Период
                    </v-th>
                    <v-th name="subscriptionDuration" width="35" tooltip="Длительность">
                        Дл
                    </v-th>
                    <v-th name="subscriptionPrice" width="50">
                        Цена
                    </v-th>
                    <v-th name="dateOfNotificationLkClose" width="70" tooltip="Дата уведомления о закрытии ЛК">
                        <i class="fas fa-lock"></i>
                    </v-th>
                    <v-th name="reportOn" sort="reportOn" width="25" tooltip="Автоматическая отправка отчетов">
                       АО
                    </v-th>
                    <v-th name="description" sort="description" minwidth="120" >
                        Коммент
                    </v-th>

                    <v-th name="proprietary" sort="proprietary" width="30" tooltip="Форма собственности">
                        ФС
                    </v-th>

                    <v-th name="locality"  width="120" tooltip="населенный пункт">
                        Нас пункт
                    </v-th>

                    <v-th name="chiefDoctor"  width="120">
                        Глав врач
                    </v-th>

                    <v-th name="nameOfficial"  width="120" tooltip="Официальное название">
                        Оф назв
                    </v-th>

                    <v-th name="licenceNum"  width="120" tooltip="Номер лицензии">
                        № Лиц
                    </v-th>

                    <v-th name="email" width="120">
                        Email
                    </v-th>
                </v-tr>

                <v-tr>
                    <v-th name="city" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...cityOptions
                            ]'
                        ></v-select>
                    </v-th>

                    <v-th name="created_at" v-slot="{filter}">
                        <date-piker v-model="filter.value"/>
                    </v-th>

                    <v-th name="moderationNeeded" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "1",
                                    text: "М"
                                }
                            ]'
                        ></v-select>
                    </v-th>

                    <v-th name="img" v-slot="{filter}">
                        <v-select v-model="filter.value"
                                  :options="[
                                  { text: '\u00a0', value: '' },
                                  { text: 'Есть', value: 'ANY' },
                                  { text: 'Нет', value: 'MISSING'},
                                ]">

                        </v-select>
                    </v-th>

                    <v-th name="nameOrAddress" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>

                    <v-th name="rating" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "-",
                                    text: "- нет"
                                },
                                {
                                    value: "1",
                                    text: "1 ★☆☆☆☆"
                                },
                                {
                                    value: "2",
                                    text: "2 ★★☆☆☆"
                                },
                                {
                                    value: "3",
                                    text: "3 ★★★☆☆"
                                },
                                {
                                    value: "4",
                                    text: "4 ★★★★☆"
                                },
                                {
                                    value: "5",
                                    text: "5 ★★★★★"
                                }
                            ]'
                        ></v-select>
                    </v-th>

                    <v-th name="network" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="parent" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="children" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="type" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    text: "\u00a0",
                                    value: ""
                                },
                                ...Object.values(clinicTypes)
                            ]'
                        ></v-select>
                    </v-th>

                    <v-th name="registryPhone" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>

                    <v-th name="doctuPhone" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>

                    <v-th name="doctors_count" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: ">0",
                                    text: "Есть врачи"
                                },
                                {
                                    value: "=0",
                                    text: "0 врачей"
                                },
                                {
                                    value: "1-5",
                                    text: "1-5 врачей"
                                },
                                {
                                    value: "6-10",
                                    text: "6-10 врачей"
                                },
                                {
                                    value: "11-20",
                                    text: "11-20 врачей"
                                },
                                {
                                    value: "21-50",
                                    text: "21-50 врачей"
                                },
                                {
                                    value: "51-100",
                                    text: "51-100 врачей"
                                },
                                {
                                    value: ">100",
                                    text: "100+ врачей"
                                },
                            ]'
                        ></v-select>
                    </v-th>

                    <v-th name="url" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>

                    <v-th name="website" v-slot="{filter}">
                        <v-input :vBeautify="striptagsTrimNoHttp" v-model="filter.value"/>
                    </v-th>

                    <v-th name="subscriptionTariff" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "*",
                                    text: "* Любой"
                                },
                                {
                                    value: "-",
                                    text: "- Без тарифа"
                                },
                                {
                                    value: "ABONEMENT",
                                    text: "Подписка Стандарт"
                                },
                                {
                                    value: "ABONEMENT_PLUS",
                                    text: "Подписка Премиум"
                                },
                                {
                                    value: "ONLY_LK",
                                    text: "Личный кабинет"
                                },
                                {
                                    value: "LK_NET",
                                    text: "Личный кабинет сети"
                                },
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="subscriptionOptions" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "*",
                                    text: "* Любая"
                                },
                                 {
                                    value: "-",
                                    text: "- Без опций"
                                },
                                {
                                    value: "OPTION_MAP",
                                    text: "Карты"
                                },
                                 {
                                    value: "OPTION_CALLBACK",
                                    text: "Обр. звонок"
                                },
                                 {
                                    value: "OPTION_CALLTRACKING",
                                    text: "Коллтрекинг"
                                },
                                 {
                                    value: "OPTION_PATIENTS_CHOICE",
                                    text: "Выбор пациентов"
                                },
                            ]'
                        />
                    </v-th>

                    <v-th name="reportManager_id" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    text: "\u00a0",
                                    value: ""
                                },
                                {
                                    value: "*",
                                    text: "Любой"
                                },
                                {
                                    value: "-",
                                    text: "- Нет"
                                },
                                ...userOptions.map(item => {
                                    return {
                                        value: item.id,
                                        text: item.fio + " - " + item.login + "(" + item.params.report.emailLogin + ")"
                                    };
                                })
                            ]'
                        ></v-select>
                    </v-th>

                    <v-th name="subscriptionActivity" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                   value: "ended15DaysAgo",
                                   text: "Завершился до 15 дней назад"
                                },
                                                        {
                                   value: "ended30DaysAgo",
                                   text: "Завершился до 30 дней назад"
                                },
                                {
                                    value: "active",
                                    text: "Активна сейчас"
                                },
                                {
                                    value: "endsIn15Days",
                                    text: "Закончится в течение 15 дней"
                                },
                                {
                                    value: "endsIn30Days",
                                    text: "Закончится в течение 30 дней"
                                },
                                {
                                    value: "endsIn3060Days",
                                    text: "Закончится через 30-60 дней"
                                },
                            ]'
                        ></v-select>
                    </v-th>

                    <v-th name="subscriptionDuration" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "*",
                                    text: "* Любой"
                                },
                                {
                                    value: "-",
                                    text: "- Нет"
                                },
                                {
                                    value: "30",
                                    text: "до 30"
                                },
                                {
                                    value: "30|89",
                                    text: "30-89"
                                },
                                {
                                    value: "90|179",
                                    text: "90-179"
                                },
                                {
                                    value: "180|359",
                                    text: "180-359"
                                },
                                {
                                    value: "360",
                                    text: "от 360"
                                },
                            ]'
                        ></v-select>
                    </v-th>

                    <v-th name="subscriptionPrice" v-slot="{filter}">
                        <v-input v-model="filter.value" highlight="*" />
                    </v-th>

                    <v-th name="dateOfNotificationLkClose" width="70" v-slot="{filter}">
                        <v-select v-model="filter.value"
                                  :options="[
                                  { text: '\u00a0', value: '' },
                                  { text: 'Уведомили', value: 'NOTIFIED' },
                                  { text: 'Не уведомили', value: 'NOT_NOTIFIED'},
                                  { text: 'Этот месяц', value: 'THIS_MONTH'},
                                  { text: 'Прошлый месяц', value: 'PREV_MONTH'},
                                ]">

                        </v-select>
                    </v-th>

                    <v-th class="fa-hack"
                        name="reportOn" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "1",
                                    text: " Да"
                                },
                                {
                                    value: "0",
                                    text: "Нет"
                                }
                            ]'
                        ></v-select>
                    </v-th>

                    <v-th name="description" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>

                    <v-th name="proprietary" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "private",
                                    text: "Ч"
                                },
                                {
                                    value: "municipal",
                                    text: "Г"
                                },
                            ]'
                        ></v-select>
                    </v-th>

                    <v-th name="locality">
                        <input type="text" disabled/>
                    </v-th>

                    <v-th name="chiefDoctor" v-slot="{filter}">
                        <v-select v-model="filter.value"
                                  :options="[
                                  { text: '\u00a0', value: '' },
                                  { text: 'Есть', value: 'ANY' },
                                  { text: 'Нет', value: 'MISSING'},
                                ]">
                        </v-select>
                    </v-th>

                    <v-th name="nameOfficial" v-slot="{filter}">
                        <v-select v-model="filter.value"
                                  :options="[
                                  { text: '\u00a0', value: '' },
                                  { text: 'Есть', value: 'ANY' },
                                  { text: 'Нет', value: 'MISSING'},
                                ]">

                        </v-select>
                    </v-th>

                    <v-th name="licenceNum" v-slot="{filter}">
                        <v-select v-model="filter.value"
                                  :options="[
                                  { text: '\u00a0', value: '' },
                                  { text: 'Есть', value: 'ANY' },
                                  { text: 'Нет', value: 'MISSING'},
                                ]">

                        </v-select>
                    </v-th>

                    <v-th name="email" v-slot="{filter}">
                        <v-select v-model="filter.value"
                                  :options="[
                                  { text: '\u00a0', value: '' },
                                  { text: 'Есть', value: 'ANY' },
                                  { text: 'Нет', value: 'MISSING'},
                                ]">

                        </v-select>
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }">
                <v-tr :class="['hover', 'pointer', {'warning': item.moderationNeeded, 'selected': multiEditSelectedIds.includes(item.id)}]"
                      @click="(row, event) => handleRowClick(event, row, item)">

                    <v-td name="city" highlight="*" width="45">
                        <span v-if="item.cityObj !== null" v-tooltip="item.cityObj.name">{{ item.cityObj.name_info.short }}</span>
                    </v-td>

                    <v-td name="created_at" highlight="*" width="70">
                        {{ item.created_at | formatDateWithShortYearAndMonth }}
                    </v-td>

                    <v-td name="moderationNeeded" align="center" width="60">
                        <div v-tooltip="'Сеть'"
                             :class="[item.hasNetworkModeration ? 'activeSource' : 'notActiveSource']"><i class="fa fa-lg fa-code-fork"></i></div>
                        <div  v-tooltip="'Клиника'"
                              :class="[item.hasClinicModeration ? 'activeSource' : 'notActiveSource']"><i class="fa fa-lg fa-building"></i></div>
                    </v-td>

                    <v-td name="img" width="50">
                        <img v-if="Object.keys(item.img).length" width="40" :src="item.img.little" alt="">
                    </v-td>

                    <v-td name="nameOrAddress" minwidth="150">
                        <div>
                            <b>{{ item.name }}</b>
                        </div>
                        <div>{{ item.address }}</div>
                    </v-td>

                    <v-td name="rating" highlight="*" align="center" width="30">
                        <span v-if="item.rating == null" v-tooltip="'Внутренний: '+ item.ratingInternal">&mdash;</span>

                        <template v-else>
                            <span v-tooltip="{content:innerTooltip(item)}">
                                {{ (Math.round(item.rating * 5 * 10) / 10).toFixed(1) }}
                            </span>
                        </template>
                    </v-td>

                    <v-td name="network" width="150">
                        <div v-if="item.networks.length>0" v-for="network in item.networks">
                            <div class="text-ellipsis">{{network.name}}</div>
                        </div>

                    </v-td>
                    <v-td name="parent" width="150">
                        <div v-if="item.parent !== null" v-bind:class="item.parent.deleted_at ? 'deleted' : ''">
                            {{ item.parent.name }}
                        </div>
                    </v-td>
                    <v-td name="children" width="150">
                        <div v-if="item.children.length>0" v-for="child in item.children">
                            <div class="text-ellipsis">{{child.name}}</div>
                        </div>
                    </v-td>
                    <v-td name="type" :highlight="searchTypeValue" width="150">
                        {{ item.typesAsText }}
                    </v-td>

                    <v-td name="registryPhone" width="115">
                        {{ item.registryPhone.replace('+', '') }}
                    </v-td>

                    <v-td name="doctuPhone" width="115">
                        {{ item.phone.replace('+', '') }}
                        <br>
                        {{ item.calltouchPhone.replace('+', '') }}
                    </v-td>

                    <v-td name="doctors_count" highlight="*" align="center" width="45">
                        {{ item.doctors_count }}
                    </v-td>

                    <v-td name="url" width="100">
                        <a class="text-ellipsis"
                           @click.prevent.stop="openHref(`${$parent.frontendUrl}/${item.city}/clinic/${item.url}`)"
                            v-tooltip="`${$parent.frontendUrl}<br/>/${item.city}/clinic/${item.url}`"
                            :href="`${$parent.frontendUrl}/${item.city}/clinic/${item.url}`"
                            target="_blank">
                            {{ item.url }}
                        </a>
                    </v-td>

                    <v-td name="website" width="120">
                        <a class="text-ellipsis"
                           @click.prevent.stop="openHref(getWebsiteUrl(item.website))"
                           :href="getWebsiteUrl(item.website)"
                           target="_blank"
                        >
                            {{ item.website }}
                        </a>
                        <a v-if="item.socialVk !== null && item.socialVk.length > 1"
                           class="text-ellipsis"
                           @click.prevent.stop="openHref('http://' + item.socialVk)"
                           :href="'http://' + item.socialVk"
                        >
                            {{ item.socialVk }}
                        </a>
                        <a v-if="item.socialOk !== null && item.socialOk.length > 1"
                           class="text-ellipsis"
                           @click.prevent.stop="openHref('http://' + item.socialOk)"
                           :href="'http://' + item.socialOk"
                        >
                            {{ item.socialOk }}
                        </a>
                        <a v-if="item.socialYoutube !== null && item.socialYoutube.length > 1"
                           class="text-ellipsis"
                           @click.prevent.stop="openHref('http://' + item.socialYoutube)"
                           :href="'http://' + item.socialYoutube"
                        >
                            {{ item.socialYoutube }}
                        </a>
                        <a v-if="item.socialTg !== null && item.socialTg.length > 1"
                           class="text-ellipsis"
                           @click.prevent.stop="openHref('http://' + item.socialTg)"
                           :href="'http://' + item.socialTg"
                        >
                            {{ item.socialTg }}
                        </a>
                        <a v-if="item.socialWhatsApp !== null && item.socialWhatsApp.length > 1"
                           class="text-ellipsis"
                           @click.prevent.stop="openHref('http://wa.me/' + item.socialWhatsApp)"
                           :href="'http://wa.me/' + item.socialWhatsApp"
                        >
                            {{ item.socialWhatsApp }}
                        </a>
                    </v-td>

                    <v-td name="subscriptionTariff" highlight="*"  width="100" >
                        <template v-if="item.subscription">
                            <span v-if="item.subscription.tariff === 'ABONEMENT'">Подписка Стандарт</span>
                            <span v-if="item.subscription.tariff === 'ABONEMENT_PLUS'">Подписка Премиум</span>
                            <span v-if="item.subscription.tariff === 'ABONEMENT_LITE'">Подписка Лайт</span>
                            <span v-if="item.subscription.tariff === 'LEADS_ALL'">Лидген</span>
                            <span v-if="item.subscription.tariff === 'LEADS_NEW'">Лидген (первичные)</span>
                            <span v-if="item.subscription.tariff === 'ONLY_LK'">Личный кабинет</span>
                            <span v-if="item.subscription.tariff === 'LK_NET'">Личный кабинет сети</span>
                        </template>
                    </v-td>

                    <v-td name="subscriptionOptions" :highlight="searchOptionValue" width="85">
                        <template v-if="item.subscription?.option_map || item.subscription?.option_patients_choice || item.subscription?.option_calltracking || item.subscription?.option_callback">
                          <template v-if="item.subscription.option_patients_choice">
                            <span>Выбор пац.</span>
                            <br>
                          </template>
                          <template v-if="item.subscription.option_map">
                                <span>Карты</span>
                                <br>
                            </template>
                            <template v-if="item.subscription.option_calltracking">
                                <span>Коллтрекинг</span>
                                <br>
                            </template>
                            <span v-if="item.subscription.option_callback">Обр. звонок</span>
                        </template>
                        <span v-else></span>
                    </v-td>

                    <v-td name="reportManager_id" highlight="*" width="70" align="center">
                        <template v-if="item.reportManager">
                            <del v-if="item.reportManager.isDeleted">
                                <span v-tooltip="item.reportManager.fio">{{ item.reportManager.fioInitials }}</span>
                            </del>
                            <span v-else v-tooltip="item.reportManager.fio">{{ item.reportManager.fioInitials }}</span>
                        </template>
                        <template v-else>
                            -
                        </template>
                    </v-td>

                    <v-td name="subscriptionActivity" highlight="*" width="75">
                        <template v-if="item.subscription">
                            {{ item.subscription.dateFrom | formatDatePeriodShort(item.subscription.dateTill) }}
                        </template>
                    </v-td>

                    <v-td name="subscriptionDuration" highlight="*" width="35">
                        <template v-if="item.subscription">
                            {{ item.subscription.duration }}
                        </template>
                    </v-td>

                    <v-td name="subscriptionPrice" width="50">
                        <template v-if="item.subscription">
                            {{ item.subscription.price }}
                        </template>
                    </v-td>

                    <v-td name="dateOfNotificationLkClose" width="70">
                        <template v-if="item.dateOfNotificationLkClose">
                            {{ item.dateOfNotificationLkClose | formatDateWithShortYearAndMonth }}
                        </template>
                    </v-td>

                    <v-td name="reportOn" highlight="*" width="25">
                        <template v-if="item.reportOn">
                            <i class="fa fa-check text-success" v-tooltip="`${item.reportToName}<br/>${item.reportTo}<br/>${item.reportCc}`"></i>
                        </template>
                    </v-td>

                    <v-td name="description" minwidth="120">
                        <template v-if="item.account">
                            {{ item.account.description }}
                        </template>
                    </v-td>

                    <v-td name="proprietary" highlight="*" width="30" align="center">
                        <template v-if="item.proprietary === 'private'">Ч</template>
                        <template v-if="item.proprietary === 'municipal'">Г</template>
                    </v-td>

                    <v-td name="locality" width="120">
                        {{ item.locality }}
                    </v-td>

                    <v-td name="chiefDoctor" width="120">
                        {{ item.chiefDoctor }}
                    </v-td>

                    <v-td name="nameOfficial" width="120">
                        {{ item.nameOfficial }}
                    </v-td>

                    <v-td name="licenceNum" width="120">
                        {{ item.licenceNum }}
                    </v-td>

                    <v-td name="email" width="120">
                        <span>{{ item.email }}</span>
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
    import ClinicEdit from "@dialogs/admin/clinics/ClinicEditDialog";
    import ClinicModeration from "@dialogs/admin/clinicModeration/Dialog";
    import ClinicNotFound from "@dialogs/ClinicNotFound";
    import GlueClinicDialog from "@dialogs/admin/clinics/clinicMerge/Dialog";

    export default {
        components: {
            GlueClinicDialog,
            ClinicNotFound,
            ClinicModeration,
            ClinicEdit
        },

        props: {
            cityOptions: {
                type: Array,
                required: true
            },

            clinicTypes: {
                type: Array,
                required: true
            },

            userOptions: {
                type: Array,
                required: true
            },
            competitors: {
                type: Array,
            }
        },

        data: function () {
            return {
                multiEditSelectedIds: []
            };
        },
        mounted: function () {
            this.checkIncomingClinic();
            this.$refs.table.update();
        },

        methods: {
            clearWHash () {
                window.location.hash = '';
            },
            checkIncomingClinic () {
                let url = this.$root.getQueryVariable('url');
                if (url !== null && url.length > 1){
                    this.axios.get('clinics/getShortInfo/' + url, {}).then(response => {

                        if (response.data.status === 'OK'){
                            if (response.data.data.moderationNeeded){
                                this.$refs.clinicModeration.showModal(response.data.data.id);
                            }else{
                                this.$refs.clinicEditDialog.read(response.data.data.id);
                            }
                        }else{
                            if (response.data.data.clinic_status !== undefined){
                                this.$refs.clinicNotFound.show(response.data.data.clinic_status);
                            }

                        }
                    });

                }
            },
            handleRowClick: function (event, row, item) {
                row.startLoadingAnimation();

                if (item.moderationNeeded) {
                    return this.moderate(item.id, row);
                }

                return this.readAccount(item.id, event, row);
            },

            openClinicGlueDialog() {
                this.$refs.glueClinicDialog.showMainFrame();
            },
            onUpdatedEvent () {
                this.$refs.table.update();
            },

            createAccount: function () {
                this.$refs.clinicEditDialog.create();
            },

            readAccount: function (clinicId, e, row) {
                this.$refs.clinicEditDialog
                    .read(clinicId)
                    .then(() => row.stopLoadingAnimation())
                    .catch(() => row.stopLoadingAnimation());
            },

            multiEditAll:  function () {
                this.model.data.map((row) => {
                    this.multiEditSelectedIds.push(row.id);
                });

                this.multiEditSelectedIds = [...new Set(this.multiEditSelectedIds)];
            },

            multiEditNone: function () {
                if (this.multiEditSelectedIds.length <= this.multiEditSelectedOnPageIds.length) {
                    this.multiEditSelectedIds = [];
                } else {
                    this.$modal('Снять галочки?', {
                        name: "Все",
                        callback: () => {
                            this.multiEditSelectedIds = [];
                        }
                    }, {
                        name: "На странице",
                        callback: () => {
                            this.model.data.map((row) => {
                                this.multiEditSelectedIds = this.multiEditSelectedOnPageIds.filter(item => {
                                    return item !== row.id;
                                });
                            });
                        }
                    });
                }
            },

            moderate: function (id, row) {
                if(this.$canNot('admin.moderation.clinics.read')){
                    this.$root.showErrorDialog({
                        message: 'Недостаточно прав для просмотра диалога модерации. Обратитесь, пожалуйста, к администратору'
                    });
                    row.stopLoadingAnimation()
                    return;
                }
                this.$refs.clinicModeration
                    .showModal(id, false)
                    .then(() => row.stopLoadingAnimation());
            },

            checkSourceMod(item, key) {
                if (key === 'externalCards') {
                    if (item[key].find(ext => ext.moderationNeeded === true)) {
                        return true;
                    }
                } else if (item[key] !== null) {
                    return item[key].moderationNeeded;
                }
                return false;
            },

            innerTooltip(item)
            {
                return `<div class="tooltip-content">
                    <table>
                        <tr><td width="85">Рейтинг:</td><td width="50">` + (Math.round(item.rating * 5 * 10) / 10).toFixed(1) + `</td></tr>
                        <tr><td>Отзывы:</td><td>` + item.ratingCommentCount + `</td></tr>
                        <tr><td>Внутренний:</td><td>` + item.ratingInternal + `</td></tr>
                    </table>
            </div>`;
            },

            openHref(href) {
                window.open(href)
            },

            getWebsiteUrl(website) {
                return website.indexOf('http') !== -1 ? website : 'http://' + website;
            }
        },

        computed: {
            striptagsTrimNoHttp () {
                return "striptags trim nohttp";
            },
            multiEditSelectedOnPageIds: function () {
                return this.model.data.map(r => this.multiEditSelectedOnPageIds.includes(r.id)) || [];
            },
            searchTypeValue: function () {
                let foundType = Object.entries(this.clinicTypes).filter(val => {
                    return val[1].value === this.$refs.table.filter.type;
                });

                return foundType !== undefined && foundType.length > 0 ? foundType[0][1].text : '';
            },
            searchOptionValue: function () {
                switch (this.$refs.table.filter.subscriptionOptions) {
                    case 'OPTION_MAP':
                        return 'Карты';
                    case 'OPTION_CALLTRACKING':
                        return 'Коллтрекинг';
                  case 'OPTION_PATIENTS_CHOICE':
                    return 'Выбор пац.';
                    case 'OPTION_CALLBACK':
                        return 'Обр. звонок';
                    case '*':
                        return '*';
                    default:
                        return '';
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    header {
        display: flex;
        justify-content: space-between;
    }
</style>
